export default "__VITE_ASSET__SVybHgCO__"